// Shared enums for flights/segments/bookings
export const flightStatuses = { 10: 'Scheduled', 20: 'Completed' };
export const flightReasons = { 10: 'Leisure', 20: 'Business', 30: 'Crew', 99: 'Other' };
export const cabinTypes = { 10: 'Economy', 20: 'Economy+', 30: 'Business', 40: 'First', 50: 'Private' };
export const seatTypes = { 10: 'Window', 20: 'Middle', 30: 'Aisle' };

export const ticketStatuses = { 10: 'Confirmed', 20: 'Replaced', 30: 'Cancelled' };
export const ticketStatusColors = { 10: 'badge-success', 20: 'badge-warning', 30: 'badge-danger' };
export const bookingStatuses = ticketStatuses;
export const segmentStatuses = ticketStatuses;

export const currencyTypes = { 10: 'Fiat', 20: 'Crypto' };

export const legsScheduleStatuses = { 0: 'Unknown', 10: 'Scheduled', 20: 'Cancelled', 30: 'Changed', 40: 'Completed' };
export const legsScheduleStatusColors = { 0: 'badge-dark', 10: 'badge-info', 20: 'badge-danger', 30: 'badge-warning', 40: 'badge-success' };

export const legTypes = { 1: 'Domestic', 2: 'International' };

export const passengerDocTypes = { 10: 'Passport', 20: 'National ID' };
export const passengerSexTypes = { 1: 'Male', 2: 'Female', 3: 'Unspecified' };

export const changeByTypes = { 10: 'Carrier', 20: 'Passenger' };
export const usageResults = { 10: 'Used', 20: 'No-show' };

export const paymentInitiators = { 10: 'Agent', 20: 'Carrier', 30: 'Individual' };
export const paymentTypes = { 10: 'Ticketing', 20: 'Change', 30: 'Cancellation', 40: 'Third Party', 50: 'Other' };
export const paymentDirections = { 10: 'Expense', 20: 'Income', 30: 'Discount' };
export const paymentSubjectTypes = { 10: 'Air Tickets', 20: 'Additional Services' };
export const paymentSubjectSubtypes = {
	21: 'Cancellation Option',
	22: 'Change Option',
	23: 'Seat Selection',
	24: 'Meals',
	25: 'Insurance'
};
